// removed by extract-text-webpack-plugin
module.exports = {"selectableItem":"SelectableList-module__selectableItem___10ZCQ","isSelected":"SelectableList-module__isSelected___7hgey","selectableItem__radio":"SelectableList-module__selectableItem__radio___2689Q","selectableItem__title":"SelectableList-module__selectableItem__title___VIuxl","selectableItem__subtitle":"SelectableList-module__selectableItem__subtitle___2W5ms"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/SelectableList/SelectableList.module.css
// module id = 263
// module chunks = 0